import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import styles from './assessor-participant-activity.styl'

export default class AssessorParticipantActivity extends Component {
  static propTypes = {
    activity: PropTypes.object,
    assessment: PropTypes.object,
    isPersonalReflectionFroActivityEnabled: PropTypes.bool
  }

  render() {
    const { activity, assessment, isPersonalReflectionFroActivityEnabled } = this.props
    let colorClass = ''

    switch (get(activity, 'activitySection.value')) {
      case ACTIVITY_SECTIONS.physical.id:
        colorClass = styles.physical
        break
      case ACTIVITY_SECTIONS.skills.id:
        colorClass = styles.skills
        break
      case ACTIVITY_SECTIONS.service.id:
        colorClass = styles.service
        break
      default:
    }

    return (
      <div className="base-margin--top">
        <h2 className="omega">
          <span className={colorClass}>
            {get(activity, 'activitySection.translationText')}
          </span>
        </h2>
        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage
              id="label.activity_type"
              defaultMessage="Activity type"
            />:{' '}
          </span>
          {get(activity, 'activityCategory.parent.translatedName')}
        </p>
        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage id="label.activity" defaultMessage="Activity" />:{' '}
          </span>
          {get(activity, 'activityCategory.translatedName')}
        </p>
        <p className={styles.goal}>
          <p className={styles.bold}>
            <FormattedMessage id="label.goal" defaultMessage="Goal" />:{' '}
          </p>
          {get(activity, 'aim')}
        </p>

        <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage
              id="label.note_from_participant"
              defaultMessage="Note from participant"
            />
            :{' '}
          </span>
          {get(assessment, 'data.note') || '---'}
        </p>

        {isPersonalReflectionFroActivityEnabled && <p className={styles.paragraph}>
          <span className={styles.bold}>
            <FormattedMessage
              id="label.personal_reflection"
              defaultMessage="Personal reflection"
            />
            :{' '}
          </span><br />
          {get(assessment, 'data.personalReflection') || '---'}
        </p>}

      </div>
    )
  }
}
